<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-购买广告
  -->
  <el-dialog
    title="购买广告"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="50%"
  >
    <div  class="active-basic">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <div class="common-form">基本信息</div>

        <el-form-item label="费用" prop="num" >
            <div>
              {{ form.num * ad.price }}元
            </div>
          </el-form-item>
          <el-form-item label="购买天数" prop="num" :rules="[{ required: true, message: '请输入购买天数', trigger: 'blur' }]">
            <el-input v-model="form.num" @input="change" type="number"  placeholder="请输入购买天数" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="结束日期" >
            {{ ad.end_time }}
          </el-form-item>
          <!-- 广告 -->
          <div v-if="add.code == 'ad'">
              <el-form-item label="设置广告图片" prop="image_id" :rules="rulesImage">
              <div class="d-c-c ad-picture" @click="openUpload">
                <img v-if="form.image_url" :src="form.image_url" width="300" height="124" />
                <span v-else class="el-icon-picture-outline"></span>
              </div>
              <p class="ml10 gray">提示：图片尺寸建议750x310</p>
            </el-form-item>

            <el-form-item label="选择跳转路径" prop="page_url" >
              <div class="url-box flex-1">
                  <span class="key-name">跳转地址：</span>
                  <el-input
                    placeholder="请选择跳转地址"
                    :value="form.page_url.name"
                  ></el-input>
                </div>
              
            
              <el-button type="primary" @click="changeLink(index)"
                    >选择链接</el-button
                  >

            </el-form-item>

          </div>
          <!-- 关键字 -->
          <div v-if="add.code == 'keyword'">
            <!-- 选择商品 -->
            <el-form-item label="商品" prop="phone" >
            
              <el-button type="primary" @click="addProduct()">选择商品</el-button>

              <div>选择的产品：{{ form.product_name }}</div>
          </el-form-item>

          </div>

          <!-- 商家排名 -->
          <div v-if="add.code == 'store'">
             <!-- 选择商品 -->
             <el-form-item label="商品" prop="phone" >
            
            <el-button type="primary" @click="addProduct()">选择商品</el-button>

            <div>选择的产品：{{ form.product_name }}</div>
        </el-form-item>
         </div>
         

          <el-form-item label="联系方式" prop="phone" :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }]">
            <el-input v-model="form.phone"  type="number"  placeholder="请输入联系方式" class="max-w460"></el-input>
          </el-form-item>


          <el-form-item label="姓名" prop="name" :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
            <el-input v-model="form.name"  placeholder="请输入姓名" class="max-w460"></el-input>
          </el-form-item>



          <div>结束时间由购买成功开始计算</div>
          <div style="height: 100px;width: 100px;"> </div>

      </el-form>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">购买</el-button>
      </div>
    </div>
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink>

        <!--选择商品-->
    <Product :isproduct="isproduct" :excludeIds="exclude_ids" :islist="false" @closeDialog="closeProductFunc"></Product>
  </el-dialog>
</template>
<script>
import AdApi from '@/api/ad.js';
import Upload from '@/components/file/Upload';
import Setlink from "@/components/setlink/Setlink";
import Product from '@/components/product/Product.vue';
export default {
  components: {
    Upload,
    Setlink,
    Product
  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传广告图'));
      } else {
        callback();
      }
    };
    return {
      /*表单对象*/
      form: {
        num:1,
        page_url:{
          page_url:"",
          name:""
        },
        product_id:0,
        product_name:""
      
      },
      ad:{
        price:9999,
        end_time:0
      },
      dialogVisible:false,
       app_id:0,
       is_edit:false,
      /*是否正在加载*/
      loading: false,
      isupload:false,
      is_linkset:false,
       /*图片是否上传了*/
       rulesImage: [{ validator: validatorImages, required: true, message: '请上传广告图', trigger: 'change' }],

       isproduct:false,
       exclude_ids:[]

    };
  },
  props:["add","open_add"],
  created() {
    //获取广告位置
    var self = this;
    self.dialogVisible = self.open_add;
    self.getAdDetail();
  },
  methods: {

    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },
      /*获取链接并关闭弹窗*/
      closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.form.page_url = {
          page_url:e.url,
          name:"链接到" + " " + e.type + " " + e.name,

        }
      }
    },
        /*上传*/
        openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.image_id = e[0].file_id;
        this.form.image_url = e[0].file_path;
      }
      this.isupload = false;
    },
    change(){
      this.getAdDetail();
    },
    getAdDetail(){
      var self = this;
      AdApi.getAdDetail({
              ad_id:self.add.ad_id,
              index:self.add.index,
              code:self.add.code,
              num:self.form.num
            }, true)
        .then(res => {
          self.ad=res.data;
          self.loading = false;
        })
    },
    /*关闭弹窗*/
    dialogFormVisible(result="") {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.$emit("close", { openDialog: false,"type":"" });
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form;
          params.ad_id = self.add.ad_id;
          params.index = self.add.index;
          params.code = self.add.code
          params.price = self.ad.price
          params.keyword =  self.ad.keyword
         
          self.loading = true;
          console.log(params);
          AdApi.buyAd(params, true)
            .then(data => {
              if(data.code == 1){
                self.$message({
                    type: 'success',
                    message: '购买成功'
                });
                self.cancelFunc()
            
                  return false;
              }
            })
            .catch(error => {});
        }
      });
    },
    
    //关键字--------------
    /*添加商品*/
    addProduct() {
      this.isproduct = true;
    },
       /*关闭商品*/
       closeProductFunc(e) {
        let self = this;
        self.isproduct = e.openDialog;
        console.log(e)
        if (e.type == 'success') {
          self.form.product_id =  e.params.product_id
          self.form.product_name =  e.params.product_name
        }
      },
  }
};
</script>

<style  lang="scss" >

.active-basic .ad-picture {
  width: 200px;
  height: 84px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;

}
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/buyAd.vue